import { format } from 'date-fns';
import { ButtonBase, Card, Divider, Stack, Typography } from '@mui/material';
import { Order } from '@/types';
import { useNavigate, useParams } from 'react-router-dom';
import routes from '@/constants/routes';
import {
  addCurrency,
  getPercentage,
  sumAmounts,
  multiplyByQuantity,
} from '@/utils/numbers';
import { useMemo } from 'react';

const OrderCard = ({ createdAt, total, number, id, items }: Order) => {
  const navigate = useNavigate();
  const { organizationId } = useParams<{ organizationId: string }>();

  const openOrderDetail = () => {
    navigate(
      routes.organizations.orders.details
        .replace(':organizationId', organizationId ?? '')
        .replace(':orderId', id)
    );
  };

  const subtotal = useMemo(() => {
    if (!items?.length) return 0;

    return items
      .map((i) => multiplyByQuantity(i.price, i.quantity))
      .reduce((acc, curr) => acc + curr, 0);
  }, [items]);

  const taxes = useMemo(() => {
    return getPercentage(subtotal, 15);
  }, [subtotal]);

  return (
    <ButtonBase
      component="div"
      onClick={openOrderDetail}
      sx={{ width: '100%' }}
    >
      <Card sx={{ backgroundColor: '#DDEAFD', width: '100%' }}>
        <Stack py={1}>
          <Stack px={1.5}>
            <Typography gutterBottom variant="h3" component="div">
              {number}
            </Typography>
          </Stack>
          <Divider />
          <Stack p={1.5} spacing={1}>
            <Stack direction="row" spacing={2} justifyContent={'space-between'}>
              <Typography variant="body2">Total</Typography>
              {total ? (
                <Typography variant="body2">
                  {addCurrency(sumAmounts([subtotal, taxes]), 'NIO')}
                </Typography>
              ) : null}
            </Stack>
            {createdAt && typeof createdAt === 'number' ? (
              <Stack
                direction="row"
                spacing={2}
                justifyContent={'space-between'}
              >
                <Typography variant="body2">Hora</Typography>
                <Typography variant="body2">
                  {format(createdAt, 'h:mma')}
                </Typography>
              </Stack>
            ) : null}
          </Stack>
        </Stack>
      </Card>
    </ButtonBase>
  );
};

export default OrderCard;
